import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import { useState } from "react";
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { logout } from '../store/slices/authSlice';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MySnackbar from "./MySnackbar";
import { useNavigate } from "react-router-dom";
import s10Logo from '../assets/images/s10Logo.png';


const drawerWidth = 240;


const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    backgroundColor: "black",
    height: "4rem !important",
    padding: "0"
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const UserMenu = () => {

    const navigate = useNavigate();
    const {user} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openModalCloseSession, setOpenModalCloseSession] = useState<boolean>(false);
    const [successMsg, setSuccessMsg] = useState<string>("");
    const [errorMsg, setErrorMsg] = useState<string>("");
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        dispatch(logout());
    };

    const handleChangePassword = () => {
        navigate('/change-password');
    };


    return (
    <Grid sx={{ display: { xs: 'flex', md: 'flex' } }} >
        <Grid 
            sx={{ display: { xs: 'none', md: 'flex' } }}
            container 
            direction={"column"} 
            margin={"0 1rem 0 .5rem"}
        >
            <Grid item>
                <Typography 
                    variant='h6'
                    style={{
                        color: "white",
                        fontFamily: "Roboto",
                        fontSize: ".875rem",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "normal",
                        marginTop: ".3rem"
                    }}
                >
                    {user?.name}
                </Typography>
            </Grid>
        </Grid>
        <IconButton
            id="demo-customized-button"
            aria-controls={open ? 'demo-customized-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            size="large"
            edge="end"
            aria-label="account of current user"
            onClick={handleClick}
            style={{margin: "0", padding: "0"}}
            color="inherit"
        >
            <KeyboardArrowDownIcon style={{fontSize: "1.5rem"}}/>
        </IconButton>
        <Menu
            id="demo-customized-menu"
            MenuListProps={{
                'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            
        >   
            <Grid container direction="column" style={{padding: "1rem"}}>
                <Grid item >
                    <Typography variant="body2">
                        {user.name}
                    </Typography>
                </Grid>
            </Grid>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem 
                onClick={handleChangePassword} 
                disableRipple
            >
                <KeyOutlinedIcon style={{fontSize: "1.25rem", color: theme.s10palette.S10Greygrey600}} />
                <Typography 
                    variant="subtitle2" 
                    marginLeft=".25rem" 
                    style={{color: theme.s10palette.S10Greygrey600}}
                >
                    Cambio de contraseña
                </Typography>
            </MenuItem>
            <MenuItem
                onClick={() => {
                    setOpenModalCloseSession(true);
                    handleClose();
                }} 
                disableRipple
            >
                <LogoutOutlinedIcon style={{fontSize: "1.25rem", color: theme.s10palette.S10Greygrey600}} />
                <Typography variant="subtitle2" marginLeft=".25rem" style={{color: theme.s10palette.S10Greygrey600}}>
                    Salir
                </Typography>
            </MenuItem>
        </Menu>
        {openModalCloseSession && 
            <Dialog
                open={openModalCloseSession}
                aria-labelledby="responsive-dialog-title"
                style={{width: "100%"}}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "25rem", 
                        maxWidth: "25rem", 
                        },
                    },
                }}
            >
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                    variant="h5"
                >
                    Cerrar sessión
                </DialogTitle>
                <DialogContent style={{width: "100%", textAlign: "center"}}>
                    <Typography variant="subtitle1">
                        ¿Deseas cerrar sesión del S10?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={6}>
                            <Button 
                                variant="outlined" 
                                style={{width: "8rem"}}
                                startIcon={<CloseIcon style={{height: "1rem"}} />}
                                onClick={() => setOpenModalCloseSession(false)}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <Button 
                                variant="contained" 
                                style={{minWidth: "8rem"}}
                                startIcon={<CheckIcon style={{height: "1rem"}} />}
                                onClick={handleLogout}
                            >
                                Cerrar sesión
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        }
        
        <MySnackbar 
            open={errorMsg !== ""}
            autoHideDuration={6000}
            msg={errorMsg}
            severity="error"
            onClose={() => setErrorMsg("")} 
        />
        <MySnackbar 
            open={successMsg !== ""}
            autoHideDuration={6000}
            msg={successMsg}
            severity="success"
            onClose={() => setSuccessMsg("")} 
        />
    </Grid>
    )
}

const AppBarMenu = () => {


    return (
        <AppBar position="fixed" elevation={0}>
            <Toolbar 
                style={{
                    height: "4rem", 
                    padding: "0 1rem"
                }}
            >
                <Grid 
                    justifyContent="center" 
                    alignItems="center" 
                    alignContent="center" 
                    item 
                    xs={6} 
                    style={{ marginTop: "0" }}
                >
                    <img style={{ height: "3rem" }} src={s10Logo} alt="S10" />
                </Grid>
                <Grid 
                    container 
                >
                    <Grid 
                        justifyContent="center" 
                        alignItems="center" 
                        alignContent="center" 
                        item 
                        xs={10} 
                        md={8}
                        style={{ marginTop: "0", paddingLeft: '1rem' }}
                        // sx={{display: {xs: 'none', md: 'block'}}}
                    >
                        |{"   "} S10 - Portal Mis Boletas
                    </Grid>
                    <Grid 
                        container 
                        item
                        xs={2}
                        md={4}
                        justifyContent="end"
                    
                    >
                        <UserMenu />
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

export default AppBarMenu;